import { Flex, IconButton, ListItem, Text, Avatar, AvatarGroup, Box, Spinner, HStack, Circle } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChecklistContext } from "providers/checklist";
import { useContext, useState } from "react";
import { AVATAR_URL } from "utils/constants";
import RangeDate from "./RangeDate";
import CheckListStatusBadge from "./CheckListStatusBadge";
import { getLastStatus } from "hooks/useChecklist";

const ChecklistItem = ({
  item,
  canEdit,
}: {
  item: any;
  canEdit: boolean;
}) => {
  const { setEditItem, toggleItem } = useContext(ChecklistContext);
  const [loading, setLoading] = useState(false);
  
  const contactsLength = item?.contacts?.length || 0;
  const documentsLength = item?.documents?.length || 0;

  const handleToggle = async () => {
    if (!canEdit) return;
    setLoading(true);
    try {
      await toggleItem(item.id, !item.completed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ListItem py="4px">
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" flex="1">
          {loading && (
            <Spinner w="12px" h="12px" mr="4px" />
          )}
          <HStack spacing={2} flex="1">
            <IconButton
              aria-label="toggle-item"
              size="xs"
              variant="ghost"
              color={item.completed ? "primary" : "gray.300"}
              onClick={handleToggle}
              isDisabled={!canEdit}
              icon={
                <Circle
                  size="20px"
                  borderWidth="2px"
                  borderColor={item.completed ? "primary" : "#E2DFE8"}
                >
                  {item.completed && (
                    <FontAwesomeIcon icon={["far", "check"]} />
                  )}
                </Circle>
              }
            />
            <Text
              fontWeight="400"
              fontSize="14px"
              color="gray.700"
              flex="1"
              noOfLines={1}
            >
              {item?.title}
            </Text>
            <RangeDate start_date={item?.start_date} due_date={item?.due_date} />
            <CheckListStatusBadge status={getLastStatus(item?.loan_item_status)?.status} />
          </HStack>
        </Flex>

        <Flex alignItems="center" ml={2}>
          {contactsLength > 0 && (
            <AvatarGroup max={2} mx="2px" spacing="4px">
              {item.contacts.map((member: any) => (
                <Avatar
                  width="20px"
                  height="20px"
                  key={member.id}
                  src={`${AVATAR_URL}${member.user.id}`}
                />
              ))}
            </AvatarGroup>
          )}

          {documentsLength > 0 && (
            <IconButton
              aria-label="item-documents"
              size="xs"
              variant="ghost"
              color="purple.600"
              isDisabled={!canEdit}
              icon={<FontAwesomeIcon icon={["far", "file"]} />}
            />
          )}

          {item?.notes && (
            <IconButton
              aria-label="item-notes"
              size="xs"
              variant="ghost"
              color="purple.600"
              isDisabled={!canEdit}
              icon={<FontAwesomeIcon icon={["far", "message"]} />}
            />
          )}

          <IconButton
            data-cy="edit-checklist-btn"
            aria-label="edit-item"
            size="xs"
            variant="ghost"
            color="purple.600"
            onClick={() => setEditItem(item)}
            isDisabled={!canEdit}
            icon={<FontAwesomeIcon icon={["far", "pencil"]} />}
          />
        </Flex>
      </Flex>
    </ListItem>
  );
};

export default ChecklistItem;